// Tour options =============================================================
import { AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

export const tour: SugarElementInfo = { name: "tour", availableChildren: { type: AvailableChildrenType.Any } };
